export default __webpack_public_path__ + "static/HistoricDistrictsOverlayZonesandFacadeImprovementGrants-76977ac338c3f52b4a5431036aec6e00.jpg";